import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navHeight: null
  },
  mutations: {
    setNavHeight (state, n) {
      state.navHeight = n
    }
  },
  actions: {
    setNavHeight: ({ commit }, payload) => {
      commit('setNavHeight', payload)
    }
  },
  modules: {
  }
})
